(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon-overview-parts/assets/javascripts/coupon-overview-reduce.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon-overview-parts/assets/javascripts/coupon-overview-reduce.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const useCouponId = svs.components.tipsen.couponId.useCouponId;
const useBranding = svs.components.tipsen.hooks.useBranding;
const selectReductionSelectionsForEvent = svs.components.tipsen.engine.selectors.couponSelectors.selectReductionSelectionsForEvent;
const selectReduction = svs.components.tipsen.engine.selectors.engineSelectors.selectReduction;
const engineConstants = svs.components.tipsen.engine.constants;
const Outcome = svs.poolBetting.components.outcome.Outcome;
const LabelMap = {
  [engineConstants.ReductionScore.HOME]: {
    labelShort: 'H',
    labelFull: 'Hemmavinst'
  },
  [engineConstants.ReductionScore.DRAW]: {
    labelShort: 'O',
    labelFull: 'Oavgjort'
  },
  [engineConstants.ReductionScore.AWAY]: {
    labelShort: 'B',
    labelFull: 'Bortavinst'
  }
};
const CouponOverviewReduce = _ref => {
  let _ref$eventNumber = _ref.eventNumber,
    eventNumber = _ref$eventNumber === void 0 ? 0 : _ref$eventNumber,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  const couponId = useCouponId();
  const _useBranding = useBranding(),
    _useBranding2 = _slicedToArray(_useBranding, 1),
    productBranding = _useBranding2[0];
  const reductionValues = useSelector(state => selectReduction(state));
  const selectedReductions = useSelector(state => selectReductionSelectionsForEvent(state, couponId, eventNumber));
  const classNames = ['pg_tipsen__outcome_row--vertical'];
  if (className) {
    classNames.push(className);
  }
  return React.createElement("div", {
    className: classNames.join(' ')
  }, reductionValues.map(value => {
    const dataTestId = "outcome_reduction_".concat(eventNumber, "_").concat(value);
    return React.createElement(Outcome, {
      ariaLabel: "Reducering ".concat(LabelMap[value].labelFull),
      branding: productBranding,
      className: "pg_overview_outcome_reduce",
      dataTestId: dataTestId,
      id: dataTestId,
      isSelected: selectedReductions.includes(value),
      key: "outcome_reduction".concat(value),
      label: LabelMap[value].labelShort
    });
  }));
};
setGlobal('svs.components.tipsen.couponOverviewParts.CouponOverviewReduce', CouponOverviewReduce);

 })(window);